import styled from 'styled-components';

export const StyledCTA = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-5);
  text-align: center;
  padding: var(--space-8) var(--space-2);

  h1 {
    font-size: var(--fs-4xl);
    font-weight: var(--fw-black);
    line-height: var(--lh-tight);
    letter-spacing: -0.02em;
  }

  p {
    max-width: 52ch;
    color: var(--c-text-muted);
    font-size: var(--fs-lg);
  }

  a {
    margin-top: var(--space-2);
    padding: var(--space-3) var(--space-6);
    background-color: var(--c-accent);
    color: #fff;
    font-weight: var(--fw-bold);
    border-radius: var(--radius-full);
    box-shadow: var(--shadow-accent);
    transition:
      background-color 0.2s ease,
      transform 0.1s ease;
  }

  a:hover {
    background-color: var(--c-accent-hover);
  }

  a:active {
    transform: translateY(1px);
  }

  @media (min-width: 786px) {
    h1 {
      font-size: var(--fs-5xl);
    }
  }

  @media (min-width: 1200px) {
    padding: var(--space-9) var(--space-2);
  }
`;
